import React, { useEffect } from "react";
import "@/App.css";
import { LanguageProvider } from "./context/LanguageContext";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import FeaturesSection from "./components/FeaturesSection";
import MenuSection from "./components/MenuSection";
import GallerySection from "./components/GallerySection";
import ReviewsSection from "./components/ReviewsSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

function App() {
  useEffect(() => {
    // Update document title
    document.title = "AK-AL Bakkerij & Eethuis | Vers Brood, Shoarma & Turkse Pizza";
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Welkom bij AK-AL! Geniet van ons dagelijks vers gebakken brood, heerlijke shoarma, döner, kapsalon en authentieke Turkse pizza\'s. 100% Halal.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Welkom bij AK-AL! Geniet van ons dagelijks vers gebakken brood, heerlijke shoarma, döner, kapsalon en authentieke Turkse pizza\'s. 100% Halal.';
      document.head.appendChild(meta);
    }

    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';
    
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="App bg-[#1A1816]" data-testid="app-container">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturesSection />
          <MenuSection />
          <GallerySection />
          <ReviewsSection />
          <ContactSection />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
